import { Col, ListCheckLineIcon, RoundElement, Row, Text } from 'ui';

const MemberAboutEmptyState = () => (
  <Row align="middle" className="member-about-empty-state" gutter={[0, 'xl']} justify="center">
    <Col span={24} textAlign="center">
      <RoundElement color="default" size="medium">
        <ListCheckLineIcon type="secondary" />
      </RoundElement>
    </Col>
    <Col span={24} textAlign="center">
      <Text size="large" weight="bold">
        User hasn’t filled any info yet
      </Text>
    </Col>
  </Row>
);

export default MemberAboutEmptyState;
